/**************************************************************************************************/
/*   File: /src/app/stores/selectors/download/selectors.ts                                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Apr 17 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducers from '../../reducers/download';
import * as fromStates from '../../states/download';

/**
 * Get the download State
 */
export const getDownloadState = createFeatureSelector<fromStates.DownloadState>('download');
/**
 * Get is loading
 */
export const getIsLoading = createSelector(
  getDownloadState,
  fromReducers.helpers.getIsLoading
);
/**
 * Get is features selected
 */
export const getFeatures = createSelector(
  getDownloadState,
  fromReducers.helpers.getFeatures
);
/**
 * Get is feature selected return true if therese more than one
 */
export const getFeatureSelected = createSelector(
  getDownloadState,
  fromReducers.helpers.getFeatureSelected
);
/**
 * Get is preparing
 */
export const getIsPreparing = createSelector(
  getDownloadState,
  fromReducers.helpers.getIsPreparing
);
/**
 * Get is ready
 */
export const getIsReady = createSelector(
  getDownloadState,
  fromReducers.helpers.getIsReady
);
/**
 * Get messages
 */
export const getMessages = createSelector(
  getDownloadState,
  fromReducers.helpers.getMessages
);
/**
 * Get dossier content
 */
export const getDossierContent = createSelector(
  getDownloadState,
  fromReducers.helpers.getDossierContent
);
/**
 * Is set plan code
 */
export const isSetPlanCode = createSelector(
  getDossierContent,
  (dossierContent) => {
    return dossierContent !== undefined && dossierContent.planCode !== undefined;
  }
);
/**
 * Is set ambito code
 */
export const isSetAmbitoCode = createSelector(
  getDossierContent,
  (dossierContent) => {
    return dossierContent !== undefined &&
      dossierContent.territorialAreasCodes !== undefined &&
      dossierContent.territorialAreasCodes.length > 0;
  }
);
/**
 * Is set spatial data type
 */
export const isSetSpatialDataType = createSelector( 
  getDossierContent,
  (dossierContent) => {
    return dossierContent !== undefined && dossierContent.defaultSpatialDataType !== undefined;
  }
);
/**
 * Get the ambiti
 */
export const getAmbiti = createSelector(
  getDownloadState,
  fromReducers.helpers.getAmbiti
);
/**
 * Get the task id
 */
export const getTaskId = createSelector(
  getDownloadState,
  fromReducers.helpers.getTaskId
);
/**
 * Get the public documents
 */
export const getPublicDocuments = createSelector(
  getDownloadState,
  fromReducers.helpers.getPublicDocuments
);
/**
 * Get the regulations response
 */
export const getRegulationsResponse = createSelector(
  getDownloadState,
  fromReducers.helpers.getRegulationsResponse
);